<template>
  <b-form>
    <div id="fulfillment-shipping">
      <div class="modal-wrp mx-1rem">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div class="information-header text-bold mb-2">
                  {{ "Shipping" }}
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Fulfillment Reference'"
                      label-for="refFulfillment"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="refFulfillment"
                        v-model="formData.fulfillmentRef"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <label class="font-medium-5">Status</label>
                    <v-select
                      class="select-format-container font-medium-5 bg-dropdown"
                      v-model="formData.statusShipping"
                      :reduce="(option) => option.value"
                      :options="optionData.statusOptions"
                      required
                      :clearable="false"
                      :disabled="disabled"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12 mt-1">
                    <label class="font-medium-5">Logistic Company</label>
                    <v-select
                      class="select-format-container font-medium-5 bg-dropdown"
                      v-model="formData.logisticValue"
                      :reduce="(option) => option.label"
                      :options="optionData.logisticOptions"
                      required
                      :clearable="false"
                      :disabled="disabled"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12 mt-1">
                    <b-form-group
                      :label="'Tracking No.'"
                      label-for="trackNo"
                      label-class="font-medium-5"
                    >
                      <b-input-group>
                        <b-form-input
                          id="trackNo"
                          :placeholder="'xx0000000000xx'"
                          class="w-100 input-wrp"
                          v-model="formData.trackNo"
                          :disabled="disabled?disabled:loadingType.onSearch"
                        />
                        <!-- <b-input-group-append>
                          <b-button class="btn-search" @click="onSearchTrackNo">
                            <span
                              v-if="loadingType.onSearch"
                              class="spinner-border spinner-border-m"
                              role="status"
                              aria-hidden="true"
                            />
                            <i v-else class="fas fa-search" />
                          </b-button>
                        </b-input-group-append> -->
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Tracking Url'"
                      label-for="trackUrl"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="trackUrl"
                        :placeholder="'http://trackingurl.com/xx0000000000xx'"
                        v-model="formData.trackUrl"
                        :disabled="disabled"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Detail'"
                      label-for="detail"
                      label-class="font-medium-5"
                    >
                      <b-form-textarea
                        id="detail"
                        v-model="formData.detail"
                        rows="4"
                        no-resize
                        :disabled="disabled"
                      ></b-form-textarea>
                    </b-form-group>
                  </div>
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Extra_ref'"
                      label-for="extraRef"
                      label-class="font-medium-5"
                    >
                      <b-form-input id="tranRef" v-model="formData.extraRef" :disabled="disabled"/>
                    </b-form-group>
                  </div>
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Extra_ref_2'"
                      label-for="extraRef2"
                      label-class="font-medium-5"
                    >
                      <b-form-input id="tranRef" v-model="formData.extraRef2" :disabled="disabled"/>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div class="information-header text-bold mb-2">
                  {{ "Order Status" }}
                </div>
                <div class="font-medium-5">
                  {{ "Logistics Tracking" }}
                </div>
                <div class="row">
                  <div class="order-status-container">
                    <div
                      class="tracking-status-progress-wrp d-flex"
                      :class="statusTracking.status >= 1 ? '' : 'in-active'"
                    >
                      <div class="tracking-status-progress-icon">
                        <icon-check />
                      </div>
                      <div class="tracking-status-progress-detail">
                        <div class="tracking-status-progress-detail-header">
                          <div class="font-medium-5">Pending</div>
                        </div>
                        <div
                          class="
                            tracking-status-progress-detail-desc
                            p-relative
                          "
                          v-if="statusTracking.status == 1"
                        >
                          <span>{{ statusTracking.dateIssue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="tracking-status-progress-line" />
                    <div
                      class="tracking-status-progress-wrp d-flex"
                      :class="statusTracking.status >= 2 ? '' : 'in-active'"
                    >
                      <div class="tracking-status-progress-icon">
                        <icon-check />
                      </div>
                      <div class="tracking-status-progress-detail">
                        <div class="tracking-status-progress-detail-header">
                          <div class="font-medium-5">Preparing</div>
                        </div>
                        <div
                          class="tracking-status-progress-detail-desc"
                          v-if="statusTracking.status == 2"
                        >
                          <span>{{ statusTracking.dateIssue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="tracking-status-progress-line" />
                    <div
                      class="tracking-status-progress-wrp d-flex"
                      :class="statusTracking.status >= 5 ? '' : 'in-active'"
                    >
                      <div class="tracking-status-progress-icon">
                        <icon-check />
                      </div>
                      <div class="tracking-status-progress-detail">
                        <div class="tracking-status-progress-detail-header">
                          <div class="font-medium-5">Packed</div>
                        </div>
                        <div
                          class="tracking-status-progress-detail-desc"
                          v-if="statusTracking.status == 5"
                        >
                          <span>{{ statusTracking.dateIssue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="tracking-status-progress-line" />
                    <div
                      class="tracking-status-progress-wrp d-flex"
                      :class="statusTracking.status >= 7 ? '' : 'in-active'"
                    >
                      <div class="tracking-status-progress-icon">
                        <icon-check />
                      </div>
                      <div class="tracking-status-progress-detail">
                        <div class="tracking-status-progress-detail-header">
                          <div class="font-medium-5">Shipped</div>
                        </div>
                        <div
                          class="tracking-status-progress-detail-desc"
                          v-if="statusTracking.status == 7"
                        >
                          <span>{{ statusTracking.dateIssue }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="tracking-status-progress-line" />
                    <div
                      class="tracking-status-progress-wrp d-flex"
                      :class="statusTracking.status == 9 ? '' : 'in-active'"
                    >
                      <div class="tracking-status-progress-icon">
                        <icon-check />
                      </div>
                      <div class="tracking-status-progress-detail">
                        <div class="tracking-status-progress-detail-header">
                          <div class="font-medium-5">Received</div>
                        </div>
                        <div
                          class="tracking-status-progress-detail-desc"
                          v-if="statusTracking.status == 9"
                        >
                          <span>{{ statusTracking.dateIssue }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import vSelect from "vue-select";
import useShippingDetailModal from "../../hook/useShippingDetailModal";
import IconCheck from "@/@core/components/svg/common/IconCheck.vue";

export default {
  props: {
    formData: { type: Object, default: {} },
    statusTracking: { type: Object, default: {} },
    disabled: {
      type: Boolean,
    }
  },
  components: {
    vSelect,
    IconCheck,
  },
  setup() {
    const { optionData, onSearchTrackNo, loadingType } =
      useShippingDetailModal();

    return {
      optionData,
      onSearchTrackNo,
      loadingType,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/fulfillment/fulfillment-modal.css";
</style>
